import React from 'react';

const Empty = (props: any) => {
  return <div></div>;
};

export default Empty;
